// extracted by mini-css-extract-plugin
module.exports = {"item-list":"Cleaning_item-list__3HdoK","detail":"Cleaning_detail__1UsKq","item-done":"Cleaning_item-done__2jpQk"};